/**
 * 검색 입력(.searchfield).
 *
 * 값이 있을 때만 지우기(×) 버튼을 보여 주기 위해 감싸는 요소에 data-empty 를 표시한다.
 * 화면에 이미 있는 검색창은 InitSearchField() 가, 나중에 만든 것은 initSearchField(field) 가 맡는다.
 * 지우면 input 이벤트를 다시 흘려보내 이 입력을 지켜보는 다른 코드도 알아채게 한다.
 */

// 검색 입력 하나를 준비한다. 나중에 만들어지는 검색창(예: 모달)은 이 함수를 직접 부른다.
export const initSearchField = (field) => {
  const input = field?.querySelector('.searchfield__input');
  const clear = field?.querySelector('[data-search-clear]');

  if (!input) {
    return;
  }

  const sync = () => {
    field.dataset.empty = '' === input.value ? 'true' : 'false';
  };

  input.addEventListener('input', sync);
  input.addEventListener('change', sync);

  clear?.addEventListener('click', () => {
    input.value = '';
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.focus();
  });

  sync();
};

const InitSearchField = () => {
  document.querySelectorAll('.searchfield').forEach(initSearchField);
};

export default InitSearchField;
